export interface DesignProduct {
  name: string;
  key: string;
  img: string;
}

export const MenuProducts: DesignProduct[] = [
  {
    name: "Traditional Menu",
    key: "menu-letter",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-Menus.webp",
  },
  {
    name: "Takeout Menu",
    key: "takeout-legal-trifold",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-TO.webp",
  },
  {
    name: "Half Page Menu",
    key: "half-page-menu",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-HalfPage.webp",
  },
  {
    name: "Kids Menu",
    key: "kids-menu-letter-landscape",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-Kids.webp",
  },
  {
    name: "Digital Menu",
    key: "digital-menu-board",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-DigiMenus.webp",
  },
];

export const MarketingProducts: DesignProduct[] = [
  {
    name: "Table Tent",
    key: "table-tent",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-TT.webp",
  },
  {
    name: "Flyer",
    key: "letter",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-Flyers.webp",
  },
  {
    name: "Poster",
    key: "poster",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-Posters.webp",
  },
  {
    name: "Business Card",
    key: "biz-card-landscape",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-BusinessCards.webp",
  },

  {
    name: "Loyalty Card",
    key: "loyalty-card-landscape",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-LoyaltyCards.webp",
  },
  {
    name: "Sticker",
    key: "sticker-portrait",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-Stickers.webp",
  },
  {
    name: "Instagram Post",
    key: "insta-post",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-IG.webp",
  },
  {
    name: "Facebook Post",
    key: "fb-post",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-FB.webp",
  },
  {
    name: "Instagram Story",
    key: "insta-story",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-IGStory.webp",
  },
  {
    name: "Facebook Story",
    key: "fb-story",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-FBStory.webp",
  },
  {
    name: "Tabletop Insert",
    key: "table-tent-insert",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-TT-Inserts.webp",
  },
  {
    name: "Logo",
    key: "logo",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-Logos.webp",
  },
  {
    name: "Sandwich Board",
    key: "sandwich-board",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-SandwichBoards.webp",
  },
  {
    name: "Food Label",
    key: "label-portrait",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-FoodLabels.webp",
  },
  {
    name: "Gift Certificate",
    key: "gift-certificate-landscape",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-GiftCerts.webp",
  },
  {
    name: "Comment Cards",
    key: "comment-card-portrait",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-CommentCards.webp",
  },
  {
    name: "Rack Cards",
    key: "rack-card-portrait",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-RackCards.webp",
  },
];

export const AllProducts: DesignProduct[] = [
  {
    name: "Traditional Menu",
    key: "menu-letter",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-Menus.webp",
  },
  {
    name: "Digital Menu",
    key: "digital-menu-board",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-DigiMenus.webp",
  },
  {
    name: "Table Tent",
    key: "table-tent",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-TT.webp",
  },
  {
    name: "Takeout Menu",
    key: "takeout-legal-trifold",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-TO.webp",
  },
  {
    name: "Half Page Menu",
    key: "half-page-menu",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-HalfPage.webp",
  },
  {
    name: "Flyer",
    key: "letter",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-Flyers.webp",
  },
  {
    name: "Kids Menu",
    key: "kids-menu-letter-landscape",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-Kids.webp",
  },
  {
    name: "Poster",
    key: "poster",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-Posters.webp",
  },
  {
    name: "Business Card",
    key: "biz-card-landscape",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-BusinessCards.webp",
  },
  {
    name: "Loyalty Card",
    key: "loyalty-card-landscape",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-LoyaltyCards.webp",
  },
  {
    name: "Sticker",
    key: "sticker-portrait",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-Stickers.webp",
  },
  {
    name: "Instagram Post",
    key: "insta-post",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-IG.webp",
  },
  {
    name: "Facebook Post",
    key: "fb-post",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-FB.webp",
  },
  {
    name: "Instagram Story",
    key: "insta-story",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-IGStory.webp",
  },
  {
    name: "Facebook Story",
    key: "fb-story",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-FBStory.webp",
  },
  {
    name: "Tabletop Insert",
    key: "table-tent-insert",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-TT-Inserts.webp",
  },
  {
    name: "Logo",
    key: "logo",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-Logos.webp",
  },
  {
    name: "Sandwich Board",
    key: "sandwich-board",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-SandwichBoards.webp",
  },
  {
    name: "Food Label",
    key: "label-portrait",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-FoodLabels.webp",
  },
  {
    name: "Gift Certificate",
    key: "gift-certificate-landscape",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-GiftCerts.webp",
  },
  {
    name: "Comment Cards",
    key: "comment-card-portrait",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-CommentCards.webp",
  },
  {
    name: "Rack Cards",
    key: "rack-card-portrait",
    img: "https://timber.mhmcdn.com/site/marketing/homepage/products-carousel/MyStuff-RackCards.webp",
  },
];
